import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/workshop1.jpg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Workshop2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("#"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            Tech <span className="purple"> Innovation </span> Workshops
            </h1>
            <p className="home-about-body">
            Our <b className="purple">Tech Innovation Workshops</b> are designed to inspire
            and equip youth and young adults with the skills they need to excel in the fast-paced fields of
            software development, electronics, and robotics. In collaboration with the <b className="purple">San Marcos Public Library</b>,
            we’ve offered impactful workshops, including <b className="purple">Web Development</b> and <b className="purple">Electrical and Robotics Engineering</b>,
            providing participants with hands-on experience in real-world projects. The Web Development workshop
            helped teens and young adults unlock their creativity by building Personal Portfolio Websites using
            HTML and CSS, while the Electrical and Robotics Engineering workshop introduced participants to
            microcontroller programming through an engaging LED Blinking Project. These workshops foster creativity,
            problem-solving, and technical skills, laying the foundation for future careers in <b className="purple">STEM</b>.
            <br />
            <br />By offering these workshops, we aim to empower the next generation of innovators with the confidence and
            practical skills to pursue careers in technology. Whether they were beginners or looking to enhance existing
            skills, participants gained valuable exposure to dynamic industries and real-world applications. These workshops
            are just one part of our broader mission to provide transformative learning experiences that create lasting social
            impact, enabling youth and young adults to contribute meaningfully to their communities and industries. At Choicest
            Fruit, we are committed to fostering a passion for STEM and opening doors to exciting career opportunities.
          
            <br />
            <br />
            
          </p>
          <Button onClick={handleClick}>Volunteer</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Workshop2;
